import {
  AnyAction,
  Reducer,
  combineReducers,
  configureStore,
} from '@reduxjs/toolkit';
import { publicApi, secureApi } from 'services/api';
import { RootState } from 'services/store.types';

export const appReducer = combineReducers({
  [publicApi.reducerPath]: publicApi.reducer,
  [secureApi.reducerPath]: secureApi.reducer,
});

const rootReducer: Reducer<RootState, AnyAction> = (state, action) => {
  if (action.type === 'store/reset' && state) {
    return appReducer(
      {
        // We must keep the API state to preserve internal subscription counters.
        // If reset, mounted components will stop receiving updates.
        [publicApi.reducerPath]: state[publicApi.reducerPath],
        [secureApi.reducerPath]: state[secureApi.reducerPath],
        // slices to keep, not included will be reset
        // ...
      },
      action,
    );
  }
  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => {
    return getDefaultMiddleware().concat(
      publicApi.middleware,
      secureApi.middleware,
    );
  },
});

export default store;
